import styled , {css} from 'styled-components';
import { DisplacementTransition } from '../../../components/loggedout/shared-styles/transitions';
import { device } from '../../../utils/responsive_utilities';

export const ChildNameContainer = styled.div`
  padding-top: 7.4rem;
  @media ${device.Tablet}{
    padding-top: 13.5rem;
  }
  @media ${device.PhoneTabletLandscape} {
    padding-top: 5.4rem;
  }
  @media ${device.Phone} {
    padding-top: 8.7rem;
  }
`;